import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "evrideo-time-slider",
  templateUrl: "./time-slider.component.html",
  styleUrls: ["./time-slider.component.scss"],
})
export class TimeSliderComponent implements OnInit {
  @Input()
  minMs: number;

  @Input()
  maxMs: number;

  @Input()
  valueMs: number;

  @Input()
  previewStepsBetween = 2;

  @Output()
  valueMsChange = new EventEmitter<number>();

  previewStepsArray = [];
  constructor() {}

  ngOnInit() {
    this.previewStepsArray = new Array(this.previewStepsBetween);
  }

  onChange(event: Event) {
    // @ts-ignore
    this.valueMsChange.emit(parseInt(event.target.value));
  }
}
